import { filterRestrictedResources } from '@eastcoal/router/utils/filterRestrictedResources'
import { transformConfigs } from '@eastcoal/router/utils/transformConfigs'
import { transformResources } from '@eastcoal/router/utils/transformResources'
import { ResourceBaseTree } from '@eastcoal/shared/components/ResourceBaseTree'
import { transformResourceTreeData } from '@eastcoal/shared/components/ResourceTree/utils/transformTreeData'

import { memberRoutes } from '../../routes/member'

import { MemberResourceTreeProps } from './interface'

const allConfigs = transformConfigs(memberRoutes)
const allResources = transformResources(allConfigs)
const restrictedResources = filterRestrictedResources(allResources)
const transformedResource = transformResourceTreeData(restrictedResources)

/**
 * 会员中心的资源树
 */
export const MemberResourceTree = ({
  checkable = true,
  onlyShowChecked = false,
  ...restProps
}: MemberResourceTreeProps) => {
  return (
    <ResourceBaseTree
      {...restProps}
      checkable={checkable}
      data={transformedResource}
      onlyShowChecked={onlyShowChecked}
    />
  )
}
